define('views/components/welcome_message/welcome_message',['require','backbone','text!templates/components/welcome_message/welcome_message.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/welcome_message/welcome_message.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp),
        className: 'alert alert-info m-t-20 welcome_message-item'
    });
});
